import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { APP_NAME } from '../../../constants';

const BenefitsPanel = () => {
  const benefits = [
    { icon: 'DollarSign', title: 'Prix transparents', description: 'Prix affiché — pas de frais cachés. Toute variation est d\'abord expliquée et validée', color: '#3b82f6' },
    { icon: 'MapPin', title: 'Suivi en temps réel', description: 'Suivez votre technicien en direct avec ETA précis et notifications automatiques', color: '#3b82f6' },
    { icon: 'Clock', title: 'Intervention rapide', description: 'Créneaux disponibles sous 1h, aujourd\'hui ou demain selon votre urgence', color: '#3b82f6' },
    { icon: 'FileText', title: 'Devis gratuit', description: 'Sur devis : diagnostic rapide, devis net avant toute action', color: '#3b82f6' },
    { icon: 'Shield', title: 'Garantie 6 mois', description: 'Toutes nos interventions sont garanties avec SAV dédié', color: '#3b82f6' },
    { icon: 'Star', title: 'Techniciens certifiés', description: 'Professionnels qualifiés avec checklists qualité et formation continue', color: '#3b82f6' }
  ];

  const testimonials = [
    {
      name: 'Marie Dubois',
      role: 'Cliente particulière',
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1671565f5-1763295143368.png",
      avatarAlt: 'Portrait professionnel',
      rating: 5,
      comment: 'Service impeccable ! Le prix annoncé était respecté et le technicien très professionnel.'
    },
    {
      name: 'Jean Martin',
      role: 'Gérant de restaurant',
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f485cebb-1766776066694.png",
      avatarAlt: 'Portrait professionnel',
      rating: 5,
      comment: 'Intervention d\'urgence résolue en 2h. Le suivi en temps réel est vraiment pratique.'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Pourquoi choisir */}
      <div className="glass-panel rounded-2xl p-6">
        <h3 className="text-lg font-semibold text-white mb-6">
          Pourquoi choisir {APP_NAME} ?
        </h3>
        
        <div className="space-y-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(59, 130, 246, 0.15)" }}>
                <Icon name={benefit?.icon} size={20} style={{ color: benefit.color }} />
              </div>
              <div>
                <h4 className="text-sm font-medium text-white mb-1">
                  {benefit?.title}
                </h4>
                <p className="text-xs text-gray-400">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Témoignages */}
      <div className="glass-panel rounded-2xl p-6">
        <h3 className="text-lg font-semibold text-white mb-4">
          Témoignages clients
        </h3>
        
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="rounded-lg p-4" style={{ background: "rgba(17, 24, 39, 0.5)" }}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0" style={{ border: "2px solid #3b82f6" }}>
                  <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-white">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs text-gray-400">
                    {testimonial?.role}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(testimonial?.rating)]?.map((_, i) => (
                    <Icon key={i} name="Star" size={14} style={{ color: "#eab308" }} />
                  ))}
                </div>
              </div>
              <p className="text-sm text-gray-300">
                "{testimonial?.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Nouveau client */}
      <div className="rounded-xl p-6" style={{ background: "linear-gradient(135deg, rgba(30, 58, 138, 0.8) 0%, rgba(59, 130, 246, 0.8) 100%)", border: "1px solid #3b82f6" }}>
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(255,255,255,0.2)" }}>
            <Icon name="Zap" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white mb-2">
              Nouveau client ?
            </h4>
            <p className="text-xs text-gray-200 mb-3">
              Créez un compte pour bénéficier de l'historique de vos services, de la gestion de vos documents et de réservations plus rapides.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-2 py-1 rounded text-xs font-medium" style={{ background: "rgba(34, 197, 94, 0.2)", color: "#22c55e" }}>
                -10% première intervention
              </span>
              <span className="px-2 py-1 rounded text-xs font-medium" style={{ background: "rgba(59, 130, 246, 0.2)", color: "#3b82f6" }}>
                Garantie étendue
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsPanel;